const body = document.body;
const nav = document.querySelector('#nav');
const openButton = document.querySelector('#mobile_navigation');
const closeButton = document.querySelector('#mobile_hide');
const contextNavigation = document.querySelector('.np-context-nav');
const mobileNavigationQuery = window.matchMedia('(max-width: 1023.98px)');
let contextButton;
let contextCloseButton;

export function setMenu(open) {
  if (!nav || !openButton || !closeButton) return;
  if (open) setContextMenu(false);
  nav.classList.toggle('mobile-in-position', open);
  closeButton.classList.toggle('x-in-position', open);
  body.classList.toggle('np-menu-open', open);
  openButton.setAttribute('aria-expanded', String(open));
  openButton.setAttribute('aria-label', open ? 'Zatvori meni' : 'Otvori meni');
  if (open) nav.querySelector('.np-primary-navigation a')?.focus();
}

export function setContextMenu(open) {
  if (!contextNavigation || !contextButton) return;
  contextNavigation.classList.toggle('np-context-nav--open', open);
  body.classList.toggle('np-context-menu-open', open);
  contextButton.setAttribute('aria-expanded', String(open));
  if (open) {
    setMenu(false);
    contextNavigation.querySelector('a')?.focus();
  }
}

function setupContextMenu() {
  if (!contextNavigation) return;
  const newsTabs = body.classList.contains('np-page-news-detail')
    ? [...document.querySelectorAll('.np-news-tabs [role="tab"]')]
    : [];
  const contextLinks = contextNavigation.querySelector('ul');
  const originalContextLinks = contextLinks?.innerHTML;
  const originalContextLabel = contextNavigation.getAttribute('aria-label');
  function syncNewsContextMenu() {
    if (!contextLinks || newsTabs.length === 0) return;
    if (!mobileNavigationQuery.matches) {
      contextLinks.innerHTML = originalContextLinks;
      contextNavigation.setAttribute('aria-label', originalContextLabel || '');
      return;
    }
    contextLinks.replaceChildren(...newsTabs.map((tab) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + tab.dataset.tabTarget;
      link.textContent = tab.textContent.trim();
      link.addEventListener('click', (event) => {
        event.preventDefault();
        tab.click();
        setContextMenu(false);
        document.getElementById(tab.dataset.tabTarget)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      item.append(link);
      return item;
    }));
    contextNavigation.setAttribute('aria-label', newsTabs[0].textContent.trim());
  }
  syncNewsContextMenu();
  mobileNavigationQuery.addEventListener('change', syncNewsContextMenu);
  const title = document.querySelector('.np-detail-hero .np-detail-heading h1')
    || document.querySelector('.page-subject-div h1');
  if (!title) return;

  contextNavigation.id = 'np-context-navigation';
  const row = document.createElement('div');
  row.className = 'np-hero-heading-row';
  title.parentNode.insertBefore(row, title);
  row.append(title);

  contextButton = document.createElement('button');
  contextButton.type = 'button';
  contextButton.className = 'np-context-toggle';
  contextButton.setAttribute('aria-label', contextNavigation.getAttribute('aria-label') || 'Otvori podmeni');
  contextButton.setAttribute('aria-controls', contextNavigation.id);
  contextButton.setAttribute('aria-expanded', 'false');
  contextButton.innerHTML = '<i class="fa-duotone fa-bars" aria-hidden="true"></i>';
  row.prepend(contextButton);

  const heading = document.createElement('div');
  heading.className = 'np-context-mobile-heading';
  heading.innerHTML = '<a href="/" class="np-mobile-brand" aria-label="Početna"><img src="/assets/images/np-pecat.svg" class="header-logo" alt="Narodno pozorište u Beogradu"></a>';
  contextCloseButton = document.createElement('button');
  contextCloseButton.type = 'button';
  contextCloseButton.className = 'np-context-close np-icon-button';
  contextCloseButton.setAttribute('aria-label', 'Zatvori podmeni');
  contextCloseButton.innerHTML = '<i class="fa-duotone fa-times" aria-hidden="true"></i>';
  heading.append(contextCloseButton);
  contextNavigation.prepend(heading);

  contextButton.addEventListener('click', () => setContextMenu(true));
  contextCloseButton.addEventListener('click', () => {
    setContextMenu(false);
    contextButton.focus();
  });
}

openButton?.addEventListener('click', () => setMenu(true));
closeButton?.addEventListener('click', () => setMenu(false));

setupContextMenu();
mobileNavigationQuery.addEventListener('change', (event) => {
  if (!event.matches) {
    setMenu(false);
    setContextMenu(false);
  }
});
